import api from '@/helpers/api';

import type {
	SubmitAskedChangesBody,
	WorkerAskedChangesResponse,
} from '@/modules/worker/components/workerAskChanges/types';

export const fetchWorkerAskedChanges = async (
	workerId: string
): Promise<WorkerAskedChangesResponse> => {
	const response = await api.request<WorkerAskedChangesResponse>({
		url: `/workers/${workerId}/asked-changes`,
		method: 'GET',
	});
	return response.data;
};

export const submitWorkerAskedChangesDecisions = async (
	workerId: string,
	body: SubmitAskedChangesBody
): Promise<void> => {
	await api.request({
		url: `/workers/${workerId}/asked-changes`,
		method: 'POST',
		data: body,
	});
};
